<div class="chat-registry-link-block" *ngIf="isReady">
  <button class="chat-registry-link-block__bubble" type="button" (click)="navigate()">
    <span class="chat-registry-link-block__title">{{ title }}</span>
    <span class="chat-registry-link-block__chips" *ngIf="appliedLabels.length">
      <span
        class="chat-registry-link-block__chip"
        *ngFor="let label of appliedLabels"
      >{{ label }}</span>
    </span>
    <span class="chat-registry-link-block__route">{{ route }}</span>
  </button>
</div>
